module.exports = __webpack_public_path__ + "media/images/icons/icon-expand-more-f42797692c75691bc8dcfeb9f0b7f285.svg";